// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { BulkMoveAppliancesData, BulkMoveAppliancesErrors, BulkMoveAppliancesResponses, CreateProgramData, CreateProgramErrors, CreateProgramResponses, CreateSectionCategoryData, CreateSectionCategoryErrors, CreateSectionCategoryResponses, CreateSectionProgrammingRangesData, CreateSectionProgrammingRangesErrors, CreateSectionProgrammingRangesResponses, CreateSiteSectionData, CreateSiteSectionErrors, CreateSiteSectionResponses, DeleteProgrammingRangeData, DeleteProgrammingRangeErrors, DeleteProgrammingRangeResponses, DeleteSectionCategoryData, DeleteSectionCategoryErrors, DeleteSectionCategoryResponses, DeleteSectionData, DeleteSectionErrors, DeleteSectionResponses, FindAllV2Data, FindAllV2Errors, FindAllV2Responses, FindSectionForestData, FindSectionForestErrors, FindSectionForestResponses, GetSectionProgrammingsPlanningData, GetSectionProgrammingsPlanningErrors, GetSectionProgrammingsPlanningResponses, GetSiteConsumptionsData, GetSiteConsumptionsErrors, GetSiteConsumptionsResponses, GetSiteProgramData, GetSiteProgramErrors, GetSiteProgramResponses, GetSiteProgramsData, GetSiteProgramsErrors, GetSiteProgramsResponses, GetSiteSectionCategoriesData, GetSiteSectionCategoriesErrors, GetSiteSectionCategoriesResponses, IsSectionDeletableData, IsSectionDeletableErrors, IsSectionDeletableResponses, MoveSectionData, MoveSectionErrors, MoveSectionResponses, PatchSiteSectionData, PatchSiteSectionErrors, PatchSiteSectionResponses, UpdateProgramData, UpdateProgramErrors, UpdateProgrammingRangeData, UpdateProgrammingRangeErrors, UpdateProgrammingRangeResponses, UpdateProgramResponses, UpdateSectionCategoryData, UpdateSectionCategoryErrors, UpdateSectionCategoryResponses, UpdateSectionsCategoriesData, UpdateSectionsCategoriesErrors, UpdateSectionsCategoriesResponses, UpdateSubprogramsData, UpdateSubprogramsErrors, UpdateSubprogramsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Find section forest for a site
 *
 * Returns the site section hierarchy as a forest. Each node contains its parent reference, appliance counts by programming category, and recursive children.
 */
export const findSectionForest = <ThrowOnError extends boolean = false>(options: Options<FindSectionForestData, ThrowOnError>) => (options.client ?? client).get<FindSectionForestResponses, FindSectionForestErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/sections/forest',
    ...options
});

/**
 * Create a site section
 *
 * Creates a section in a site, optionally under a parent section. Returns the created section reference.
 */
export const createSiteSection = <ThrowOnError extends boolean = false>(options: Options<CreateSiteSectionData, ThrowOnError>) => (options.client ?? client).post<CreateSiteSectionResponses, CreateSiteSectionErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/sections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a site section
 *
 * Deletes a site section from a site.
 */
export const deleteSection = <ThrowOnError extends boolean = false>(options: Options<DeleteSectionData, ThrowOnError>) => (options.client ?? client).delete<DeleteSectionResponses, DeleteSectionErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/sections/{sectionId}',
    ...options
});

/**
 * Patch a site section
 *
 * Updates provided fields of a site section. Omitted fields are left unchanged.
 */
export const patchSiteSection = <ThrowOnError extends boolean = false>(options: Options<PatchSiteSectionData, ThrowOnError>) => (options.client ?? client).patch<PatchSiteSectionResponses, PatchSiteSectionErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sections/{sectionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check whether a site section is deletable
 *
 * Returns whether the site section can be deleted.
 */
export const isSectionDeletable = <ThrowOnError extends boolean = false>(options: Options<IsSectionDeletableData, ThrowOnError>) => (options.client ?? client).get<IsSectionDeletableResponses, IsSectionDeletableErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sections/{sectionId}/is-deletable',
    ...options
});

/**
 * Move a site section
 *
 * Moves a site section under a new parent section, or to the root when no parent is provided.
 */
export const moveSection = <ThrowOnError extends boolean = false>(options: Options<MoveSectionData, ThrowOnError>) => (options.client ?? client).post<MoveSectionResponses, MoveSectionErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sections/{sectionId}/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update the links between sections and categories
 *
 * Update the links between sections and categories. If the provided category ID is null, the section is no longer associated with a category
 */
export const updateSectionsCategories = <ThrowOnError extends boolean = false>(options: Options<UpdateSectionsCategoriesData, ThrowOnError>) => (options.client ?? client).post<UpdateSectionsCategoriesResponses, UpdateSectionsCategoriesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/sections/update-sections-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all sections categories for a given site
 *
 * Get all section categories for a given site, with information like if the category is deletable
 */
export const getSiteSectionCategories = <ThrowOnError extends boolean = false>(options: Options<GetSiteSectionCategoriesData, ThrowOnError>) => (options.client ?? client).get<GetSiteSectionCategoriesResponses, GetSiteSectionCategoriesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/section-categories',
    ...options
});

/**
 * Create a site section category
 *
 * Create a new section category linked to a site, used for programming
 */
export const createSectionCategory = <ThrowOnError extends boolean = false>(options: Options<CreateSectionCategoryData, ThrowOnError>) => (options.client ?? client).post<CreateSectionCategoryResponses, CreateSectionCategoryErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/section-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a site section category
 *
 * Delete a section category linked to a site. No section must be linked
 */
export const deleteSectionCategory = <ThrowOnError extends boolean = false>(options: Options<DeleteSectionCategoryData, ThrowOnError>) => (options.client ?? client).delete<DeleteSectionCategoryResponses, DeleteSectionCategoryErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/section-categories/{sectionCategoryId}',
    ...options
});

/**
 * Update a site section category
 *
 * Update a section category linked to a site
 */
export const updateSectionCategory = <ThrowOnError extends boolean = false>(options: Options<UpdateSectionCategoryData, ThrowOnError>) => (options.client ?? client).patch<UpdateSectionCategoryResponses, UpdateSectionCategoryErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/section-categories/{sectionCategoryId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an identical range for several sections
 *
 * Creates or updates the programming of several site sections by applying a shared programming range (a program over a time window) to each of them.
 */
export const createSectionProgrammingRanges = <ThrowOnError extends boolean = false>(options: Options<CreateSectionProgrammingRangesData, ThrowOnError>) => (options.client ?? client).post<CreateSectionProgrammingRangesResponses, CreateSectionProgrammingRangesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/create-programming-ranges',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the section programmings planning of a site
 *
 * Returns the site section hierarchy as a forest. Each node carries its parent reference, its category, the number of programmable appliances by programming category, and the programming ranges applied to the section.
 */
export const getSectionProgrammingsPlanning = <ThrowOnError extends boolean = false>(options: Options<GetSectionProgrammingsPlanningData, ThrowOnError>) => (options.client ?? client).get<GetSectionProgrammingsPlanningResponses, GetSectionProgrammingsPlanningErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/section-programmings-planning',
    ...options
});

/**
 * Update a programming range of a site section
 *
 * Updates one programming range of a site section, identified by its UUID. Only the provided fields are applied, omitted fields are left unchanged.
 */
export const updateProgrammingRange = <ThrowOnError extends boolean = false>(options: Options<UpdateProgrammingRangeData, ThrowOnError>) => (options.client ?? client).patch<UpdateProgrammingRangeResponses, UpdateProgrammingRangeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/sections/{sectionId}/update-programming-range',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a programming range of a site section
 *
 * Deletes one programming range of a site section, identified by its UUID.
 */
export const deleteProgrammingRange = <ThrowOnError extends boolean = false>(options: Options<DeleteProgrammingRangeData, ThrowOnError>) => (options.client ?? client).delete<DeleteProgrammingRangeResponses, DeleteProgrammingRangeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/sections/{sectionId}/delete-programming-range',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a site program
 *
 * Creates a program for a site, with its subprograms. Returns the created program reference.
 */
export const createProgram = <ThrowOnError extends boolean = false>(options: Options<CreateProgramData, ThrowOnError>) => (options.client ?? client).post<CreateProgramResponses, CreateProgramErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/programs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a program with its subprograms
 *
 * Returns a site program with the weekly programming ranges of its subprograms, for the requested appliance categories.
 */
export const getSiteProgram = <ThrowOnError extends boolean = false>(options: Options<GetSiteProgramData, ThrowOnError>) => (options.client ?? client).get<GetSiteProgramResponses, GetSiteProgramErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/programs/{programId}',
    ...options
});

/**
 * Update a program
 *
 * Updates provided fields of a site program. Omitted fields are left unchanged.
 */
export const updateProgram = <ThrowOnError extends boolean = false>(options: Options<UpdateProgramData, ThrowOnError>) => (options.client ?? client).patch<UpdateProgramResponses, UpdateProgramErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/programs/{programId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update the subprograms of a program
 *
 * Creates or updates the subprograms of a program for the given appliance categories. Appliance categories not included in the payload are left unchanged. May be empty.
 */
export const updateSubprograms = <ThrowOnError extends boolean = false>(options: Options<UpdateSubprogramsData, ThrowOnError>) => (options.client ?? client).patch<UpdateSubprogramsResponses, UpdateSubprogramsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/programs/{programId}/subprograms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the programs of a site
 *
 * Returns the site programs, ordered by program ID. One of them is flagged as the site default program.
 */
export const getSitePrograms = <ThrowOnError extends boolean = false>(options: Options<GetSiteProgramsData, ThrowOnError>) => (options.client ?? client).get<GetSiteProgramsResponses, GetSiteProgramsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/programs',
    ...options
});

/**
 * Get the consumption of a site
 *
 * Returns the consumption of one site over a date range: the metering (DSO) figures, the Voltalis device figures, and their breakdown by day, by appliance category and by site section. The perimeter can be narrowed to part of the site sections.
 */
export const getSiteConsumptions = <ThrowOnError extends boolean = false>(options: Options<GetSiteConsumptionsData, ThrowOnError>) => (options.client ?? client).post<GetSiteConsumptionsResponses, GetSiteConsumptionsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/consumption/site/{siteId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List programmable appliances of a section
 *
 * Returns the programmable appliances directly attached to the given site section.
 */
export const findAllV2 = <ThrowOnError extends boolean = false>(options: Options<FindAllV2Data, ThrowOnError>) => (options.client ?? client).get<FindAllV2Responses, FindAllV2Errors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sections/{sectionId}/appliances-v2',
    ...options
});

/**
 * Move appliances to a section in bulk
 *
 * Moves the given appliances of a site to a target site section.
 */
export const bulkMoveAppliances = <ThrowOnError extends boolean = false>(options: Options<BulkMoveAppliancesData, ThrowOnError>) => (options.client ?? client).post<BulkMoveAppliancesResponses, BulkMoveAppliancesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'Authentication',
            type: 'apiKey'
        }, { name: 'VoltalisApplication', type: 'apiKey' }],
    url: '/kli/voltalis-hospitality/sites/{siteId}/appliances/bulk-move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
